<template>
    <div>
        <h1>Daily Disbursement Report</h1>
    </div>
</template>

<script>
import { userStatistics } from '@/webpublicapi/vietnamBackstage'
export default {
    name: 'lending',
    data() {
        return {

        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            userStatistics().then(res => {
                console.log(res)
            }).catch(err => {
                console.log(err)
            })
        }
    },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>